// Dependencies
import styled, { css } from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    display: flex;

    .wrapper-input {
        width: 20px;
        height: 20px;
        display: inline-block;
    }
`;

type LabelStyleProps = {
    type: "input" | "container";
    isDisabled: boolean;
    isChecked: boolean;
};

export const Label = styled.label<LabelStyleProps>`
    ${({ type, isDisabled, isChecked }) =>
        type === "input" &&
        css`
            &::before {
                content: "";
                background: transparent;
                border-radius: 100%;
                border-width: 2px;
                border-style: solid;
                border-color: ${theme.colors.base[300]};
                display: inline-block;
                width: 100%;
                height: 100%;
                position: relative;
                top: -0.2em;
                margin-right: 1em;
                vertical-align: top;
                cursor: pointer;
                text-align: center;
                transition: all 250ms ease;

                ${!!isChecked &&
                    css`
                        border-color: ${theme.colors.base[500]};
                        background: ${theme.colors.base[500]};
                        box-shadow: inset 0 0 0 3px ${theme.colors.base[100]};
                    `}

                ${!!isDisabled &&
                    !isChecked &&
                    css`
                        border-color: ${theme.colors.base[200]};
                    `}

                ${!!isDisabled &&
                    !!isChecked &&
                    css`
                        border-color: ${theme.colors.base[200]};
                        background: ${theme.colors.base[200]};
                        box-shadow: inset 0 0 0 3px ${theme.colors.base[100]};
                    `}
                
                
            }

        `}

    ${({ type }) =>
        type === "container" &&
        css`
            font-family: "Nunito", sans-serif;
            font-style: normal;
            font-size: 0.875rem;
            font-weight: 400;

            letter-spacing: 0;
            line-height: 1.428;

            cursor: pointer;

            span {
                margin-left: 0.625em;
            }

            &.disabled {
                color: ${theme.colors.base[200]};
            }
        `}
`;

export const RadioInput = styled.input`
    position: absolute;
    opacity: 0;
`;
